<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ContactsList from "./contacts-list";
export default {
  components: { Layout, PageHeader, ContactsList },
  data() {
    return {};
  },
};
</script>

<template>
  <Layout>
    <contacts-list />
  </Layout>
</template>